import React from 'react';
import './QuickStats.css';

function QuickStats({ stats }) {
  const quickStats = [
    { label: 'Active Users', value: stats?.activeUsers || 0, icon: '👥', color: '#3b82f6' },
    { label: 'Entries Today', value: stats?.entriesToday || 0, icon: '🎯', color: '#10de82' },
    { label: 'New Giveaways', value: stats?.newGiveaways || 0, icon: '🎁', color: '#f59e0b' },
    { label: 'Wins Today', value: stats?.winsToday || 0, icon: '🏆', color: '#ef4444' },
  ];

  return (
    <div className="quick-stats">
      {quickStats.map((stat, index) => (
        <div 
          key={index} 
          className="quick-stat-card"
          style={{ '--stat-color': stat.color }}
        >
          <div className="quick-stat-icon">{stat.icon}</div>
          <div className="quick-stat-content">
            <div className="quick-stat-value">{stat.value}</div>
            <div className="quick-stat-label">{stat.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default QuickStats;

